import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../css/Member/Register/registerSuccess.css'
import * as countryCodes from 'country-codes-list';

function RegisterSuccess({ data }) {
    const navigate = useNavigate();

    const formatBirthdate = (dateString) => {
        if (!dateString) return '';
        
        // "1999/09/17" → [1999, 09, 17]
        const parts = dateString.split('/');
        if (parts.length === 3) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);
            return `${year}년 ${month}월 ${day}일`;
        }

        const date = new Date(dateString);
        
        if (isNaN(date)) return dateString; // 파싱 실패 시 원본 출력

        return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
    };

    const cc = useMemo(() => {
        const lib = (countryCodes && countryCodes.customList)
          ? countryCodes
          : (countryCodes && countryCodes.default && countryCodes.default.customList)
            ? countryCodes.default
            : null;
        return lib;
    }, []);

    const dialList = useMemo(() => {
        if (!cc) return [];
        // unique dial codes with '+' prefix
        const map = cc.customList('countryCode', '{countryCallingCode}');
        const set = new Set(Object.values(map).filter(Boolean).map((c) => `+${c}`));
        return Array.from(set).sort((a, b) => b.length - a.length); // longest first
    }, [cc]);

    const phoneParsed = useMemo(() => {
        const result = { code: '', local: '' };
        const full = (data?.phone || '').trim();
        if (!full) return result;
        // If separate fields exist, honor them first
        if (data?.phoneCode && data?.phone) {
            return { code: data.phoneCode, local: data.phone };
        }
        // Try to split using known dial codes
        const match = dialList.find((dc) => full.startsWith(dc));
        if (match) {
            return { code: match, local: full.slice(match.length) };
        }
        // Fallback: naive split + up to 3 digits after '+'
        const m = full.match(/^(\+\d{1,3})(.*)$/);
        if (m) return { code: m[1], local: m[2] };
        // As-is fallback
        return { code: '', local: full };
    }, [data, dialList]);

    return (
        <div className="register-success">
            <div className='regist-success-title'>
                <h2>가입이 <span>완료</span>되었습니다!</h2>
                <p>와우크루즈의 회원이 되신걸 환영합니다.<br/>와우크루즈에서 다양한 크루즈 티켓 상품을 만나보세요.</p>
            </div>

            <div className='regist-success-data-wrapper'>
                <div className='regist-success-data'>
                    <p className='regist-success-name'>아이디</p>
                    <p className='regist-success-value'>{data.id}</p>
                </div>
                <div className='regist-success-data'>
                    <p className='regist-success-name'>이름</p>
                    <p className='regist-success-value'>{data.user_name}</p>
                </div>
                <div className='regist-success-data'>
                    <p className='regist-success-name'>거주 국가</p>
                    <p className='regist-success-value'>{data.country} ({data.region})</p>
                </div>
                <div className='regist-success-data'>
                    <p className='regist-success-name'>생년월일</p>
                    <p className='regist-success-value'>{formatBirthdate(data.birthday)}</p>
                </div>
                <div className='regist-success-data'>
                    <p className='regist-success-name'>성별</p>
                    <p className='regist-success-value'>{data.sex === 'M' ? '남성' : '여성' }</p>
                </div>
                <div className='regist-success-data'>
                    <p className='regist-success-name'>휴대폰 번호</p>
                    <p className='regist-success-value'>
                        {phoneParsed.code ? `(${phoneParsed.code}) ` : ''}{phoneParsed.local}
                    </p>
                </div>
            </div>

            <div className='btn-wrapper'>
                <button type='button' className='btn home-btn' onClick={() => navigate('/')}>메인페이지로</button>
                <button type='button' className='btn login-btn' onClick={() => navigate('/login')}>로그인 하기</button>
            </div>
        </div>
    );
}

export default RegisterSuccess;
